import React from "react"
import styled from "styled-components"
import { AppFunctionComponent, JobOffer } from "../../types"
import { NeutralRawLink } from "../../ui/components/link/link.component"
import { smallBodyTextStyles } from "../common/general-styles.component"

const CareerTitle = styled.h3`
  ${smallBodyTextStyles};
  display: block;
  margin: 25px 0;
  @media (max-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    max-width: 200px;
  }
`

const CareerBar = styled(NeutralRawLink)`
  display: flex;
  justify-content: space-between;
  align-content: center;
  border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
  padding: 0 15px;
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 0 50px;
  }

  &:hover {
    ${CareerTitle} {
      color: ${({ theme }) => theme.color.linkHover};
    }
  }
`

const CareerTypeContainer = styled.div`
  display: flex;
  align-items: center;
`

const CareerType = styled.p`
  margin-left: 30px;
  font-size: ${11 / 16}rem;
  line-height: ${14 / 11};
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    font-size: ${14 / 16}rem;
    line-height: ${32 / 14};
  }
`

const CareerOffers: AppFunctionComponent<JobOffer> = ({
  city,
  jobType,
  slug,
  title,
}) => {
  return (
    <CareerBar to={`/career/${slug}`}>
      <CareerTitle>{title}</CareerTitle>
      <CareerTypeContainer>
        <CareerType>
          {jobType}, {city}
        </CareerType>
      </CareerTypeContainer>
    </CareerBar>
  )
}

export default CareerOffers
